<template>
  <div class="content-container">
    <search-comp @onSearch="attachData" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Mã đặt phòng</div>
                <div class="child-w-80">
                  <!-- v-model="searchParams.roomNumber" -->
                  <input v-model="searchParams.bookingCode" type="text" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Khách sạn</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.hotelId"
                    :disabled="disabledDate"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>

            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Từ ngày</div>
                <div class="child-w-80">
                  <!-- :date-data="agentItem.representative_card_date" -->
                  <!-- v-model="agentItem.representative_card_date" -->
                  <!-- @changeCalendar="onChangeDate2" -->
                  <CalendarRange
                    v-model="datetimeRange"
                    style="display: block; width: 500px"
                    :disabled="disabledDate"
                    mode="date"
                    @input="setDateRange"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Nguồn</div>
                <div class="child-w-80">
                  <!-- v-model="searchParams.roomNumber" -->
                  <select-with-search-table
                    style="width: 100%"
                    :rows="sourceOptions"
                    :columns="columnsSource"
                    index-field="id"
                    :is-remove-btn="true"
                    :disabled="disabledDate"
                    :dropdown-width="400"
                    :selected-index-field-value="searchParams.sourceId"
                    :value="searchParams.sourceId"
                    @selectionChanged="onSelectRowSource"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      {{ selectedData?.desc }}
                    </template>
                  </select-with-search-table>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Nhân viên đặt phòng</div>
                <div class="child-w-80">
                  <select-with-search-table
                    style="width: 100%"
                    :rows="agentOptions"
                    :columns="columnsAgent"
                    :is-remove-btn="true"
                    index-field="id"
                    :disabled="disabledDate"
                    :dropdown-width="400"
                    :selected-index-field-value="searchParams.userId"
                    :value="searchParams.userId"
                    @selectionChanged="onSelectRowAgent"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      {{ selectedData?.full_name }}
                    </template>
                  </select-with-search-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">Báo cáo đặt phòng</span>
            </div>
            <div class="button-containers-title">
              <InfoBtn @click="dialogFormVisible = true" />
              <el-dropdown trigger="click" @command="handleCommand">
                <button class="btn medium primary outline download-button">
                  <i class="el-icon-download"></i>
                </button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">Xuất PDF</el-dropdown-item>
                  <el-dropdown-item command="excel"
                    >Xuất Excel</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <button class="btn primary small">Xuất Excel</button> -->
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr />
          <div class="w-full">
            <el-table
              class="report-table overflow-auto"
              :height="'700px'"
              :data="rows"
              :border="true"
              :span-method="objectSpanMethod"
            >
              <el-table-column
                v-for="(item, index) in columns"
                :key="index"
                :prop="item.field"
                :label="item.headerName"
                :min-width="item?.minWidth || 100"
                :header-align="'left'"
                :align="item.cellClass === 'ag-cell-right' ? 'right' : null"
                :formatter="
                  formatNumberField.includes(item.field) ? displayNumber : null
                "
              >
              </el-table-column>
            </el-table>
          </div>
          <!-- <div v-loading="loading" class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              dom-layout="scroll"
              class="agGrid"
              :header-height-setter="headerHeightSetter"
              row-selection="false"
              :suppress-cell-focus="true"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              :auto-select-first-row="false"
              :suppress-row-transform="true"
              :auto-size-cell="true"
            />
          </div> -->
        </div>
      </div>
    </div>

    <el-dialog
      title="Chú thích"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Mã đặt phòng: Hiển thị mã đặt phòng</li>
            <li>Số lượng phòng đặt: Hiển thị số phòng đặt</li>
            <li>Tên khách: Hiển thị thông tin khách đặt</li>
            <li>Nguồn: Hiển thị nguồn của đặt phòng</li>
            <li>Hạng phòng: Hiển thị Mã hạng phòng</li>
            <li>Số lượng phòng theo hạng phòng:</li>
            <li>
              Ngày đặt : hiển thị ngày, thời gian đặt phòng theo format:
              DDMMYYYY HHMM
            </li>
            <li>Ngày đến: Ngày đến của đặt phòng</li>
            <li>Ngày đi: Hiển thị ngày đi của đặt phòng</li>
            <li>Số lượng khách: số lượng khách theo hạng phòng</li>
            <li>
              Số đêm: Hiển thị số đêm đặt chia theo khoảng thời gian mã giá.
            </li>
            <li>Giá phòng: Hiển thị giá phòng</li>
            <li>
              Doanh thu thực: Hiển thị doanh thu thự là doanh thu sau khi áp
              dụng các chương trình giảm giá khi đặt phòng. Tính theo: Doanh thu
              thực = số đêm*Giá phòng giảm giá khi đặt phòng
            </li>
            <li>Nhân viên: Nhân viên tạo đặt phòng</li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import InfoBtn from './components/InfoBtn.vue'
import { getAllHotel } from '@/api/hotel'
import {
  getListReservationReport,
  getListReservationReportExcel,
  getAllFO,
  getAllSales
} from '@/api/report_service/reservationReport'
import { DEFAULT_GRID_ROW_HEIGHT } from '@/constant'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import { getSourceApi } from '@/api/Statistics/source'

const rowSpan = params => {
  if (params.data.rowSpan) {
    return params.data.rowSpan
  }

  return 1
}
const rowSpan1 = params => {
  if (params.data.rowSpan1) {
    return params.data.rowSpan1
  }

  return 1
}

const cellStyle = params => {
  if (params.data.rowSpan)
    return {
      height: `${DEFAULT_GRID_ROW_HEIGHT * params.data.rowSpan}px`,
      'border-left': '0.5px solid #ccc',
      'border-right': '0.5px solid #ccc',
      'border-bottom': '0.5px solid #ccc',
      top: 0,
      background: '#fff'
    }
}
const cellStyle1 = params => {
  if (params.data.rowSpan1)
    return {
      height: `${DEFAULT_GRID_ROW_HEIGHT * params.data.rowSpan1}px`,
      'border-left': '1px solid #ccc',
      // 'border-right': '1px solid #ccc',
      'border-bottom': '0.5px solid #ccc',
      top: 0,
      background: '#fff'
    }
}
const cellStyle2 = () => {
  return {
    'border-left': '1px solid #ccc',
    // 'border-right': '1px solid #ccc',
    'border-bottom': '0.5px solid #ccc',
    top: 0,
    background: '#fff'
  }
}

export default {
  components: {
    CalendarRange,
    InfoBtn,
    SelectWithSearchTable
  },
  data() {
    return {
      disabledDate: false,
      loading: false,
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        // wrapText: true,
        // autoHeight: true,
        suppressMovable: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },

      defaultDatetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      datetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      dialogFormVisible: false,
      hotelList: [],
      searchParams: {
        hotelId: [],
        bookingCode: '',
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        userId: '',
        sourceId: ''
      },
      defaultSearchParams: {
        hotelId: [],
        bookingCode: '',
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        userId: '',
        sourceId: ''
      },
      agentOptions: [],
      sourceOptions: [],
      columnsAgent: [
        {
          headerName: 'ID Nhân viên',
          field: 'code',
          minWidth: 150,
          maxWidth: 150
        },
        {
          headerName: 'Họ và tên',
          field: 'full_name',
          flex: 1
        }
      ],
      columnsSource: [
        {
          headerName: 'Mã nguồn',
          field: 'code',
          minWidth: 120,
          maxWidth: 150
        },
        {
          headerName: 'Mô tả',
          field: 'desc',
          // tooltipFiled: 'desc',
          flex: 1
        }
      ],
      columns: [
        // {
        //   headerName: '',
        //   field: 'index',
        //   minWidth: 60,
        //   maxWidth: 60,
        //   headerCheckboxSelection: true,
        //   headerCheckboxSelectionFilteredOnly: true,
        //   checkboxSelection: true,
        //   resizable: false
        //   // cellStyle: {'padding-left': '12px'}
        // },
        {
          headerName: this.$t('grid.column.bookingCode'),
          field: 'code',
          // cellClass: "grid-cell-centered",
          sortable: false,
          minWidth: 120,
          maxWidth: 115,
          rowSpan: rowSpan,
          cellRenderer: params => {
            if (params.value) {
              return `<span>${params.value}</span>`
            }
          },
          tooltipField: 'code',
          // cellClass: "grid-cell-centered",
          cellStyle: cellStyle
        },

        {
          headerName: this.$t('grid.column.customerName'),
          field: 'booker',
          tooltipField: 'booker',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 120,
          rowSpan: rowSpan,
          cellRenderer: params => {
            if (params.value) {
              return `<span>${params.value}</span>`
            }
          },
          // cellClass: "grid-cell-centered",
          cellStyle: cellStyle
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.source'),
          field: 'source_name',
          tooltipField: 'source_name',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 110,
          maxWidth: 150,
          rowSpan: rowSpan,
          cellRenderer: params => {
            if (params.value) {
              return `<span>${params.value}</span>`
            }
          },
          // cellClass: "grid-cell-centered",
          cellStyle: cellStyle
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.roomLevel'),
          field: 'room_level_name',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 120,
          rowSpan: rowSpan1,
          cellRenderer: params => {
            if (params.value) {
              return `<span>${params.value}</span>`
            }
          },
          // cellClass: "grid-cell-centered",
          cellStyle: cellStyle1,
          tooltipField: 'room_level_name'

          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.quantity'),
          field: 'num_of_rooms',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 90,
          maxWidth: 100,
          rowSpan: rowSpan1,
          cellRenderer: params => {
            if (params.value) {
              return `<span>${params.value}</span>`
            }
          },
          // cellClass: "grid-cell-centered",
          cellStyle: cellStyle1
          // cellClass: "grid-cell-centered",
        },

        {
          headerName: this.$t('grid.column.dateOrder'),
          field: 'booked_date',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 120,
          maxWidth: 120,
          rowSpan: rowSpan,

          cellRenderer: params => {
            if (params.value) {
              return `<span>${this.$moment(params.value).format(
                'DD-MM-YYYY'
              )}</span>`
            }
          },
          // cellClass: "grid-cell-centered",
          cellStyle: cellStyle
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.comeDate'),
          field: 'arrive_date',
          // cellRenderer: 'CellRenderTextInput',
          valueGetter: params => {
            if (params.data.arrive_date) {
              return this.$moment(params.data.arrive_date).format('DD-MM-YYYY')
            } else {
              return ''
            }
          },
          sortable: false,
          minWidth: 120,
          maxWidth: 120,
          cellStyle: cellStyle2
        },
        {
          headerName: this.$t('grid.column.departDate'),
          field: 'depart_date',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          valueGetter: params => {
            if (params.data.depart_date) {
              return this.$moment(params.data.depart_date).format('DD-MM-YYYY')
            } else {
              return ''
            }
          },
          minWidth: 120,
          maxWidth: 120,
          cellStyle: cellStyle2

          // cellStyle:
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.numGuest'),
          field: 'num_of_guests',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 100,
          maxWidth: 100,
          cellStyle: cellStyle2

          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.numNight'),
          field: 'num_of_nights',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 60,
          maxWidth: 70,
          cellStyle: cellStyle2

          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.averagePriceRoom'),
          field: 'average_charge',
          tooltipField: 'average_charge',

          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 120,
          maxWidth: 120,
          rowSpan: rowSpan1,
          cellRenderer: params => {
            if (params.value !== null && params.value !== undefined) {
              return `<span>${Number(params.value).toLocaleString('en')}</span>`
            }
          },
          tooltipValueGetter: params => {
            if (params.value !== null && params.value !== undefined) {
              return `<span>${Number(params.value).toLocaleString('en')}</span>`
            }
          },
          // cellClass: "grid-cell-centered",
          cellStyle: cellStyle1
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.discount'),
          field: 'discount',
          rowSpan: rowSpan,
          cellRenderer: params => {
            if (
              params.data.discount !== null &&
              params.data.discount !== undefined
            ) {
              return `<span>${Number(params.data.discount).toLocaleString(
                'en'
              )}</span>`
            }
          },
          tooltipValueGetter: params => {
            return this.$displayCurrency(params.data.discount)
          },
          // cellClass: "grid-cell-centered",
          cellStyle: cellStyle,
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 110,
          maxWidth: 110
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.refund'),
          field: 'refund',
          rowSpan: rowSpan,
          cellRenderer: params => {
            if (params.value !== null && params.value !== undefined) {
              return `<span>${Number(params.value).toLocaleString('en')}</span>`
            }
          },
          tooltipValueGetter: params => {
            return this.$displayCurrency(params.data.refund)
          },
          // cellClass: "grid-cell-centered",
          cellStyle: cellStyle,
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 110,
          maxWidth: 110
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.realRevenue'),
          field: 'revenue',
          rowSpan: rowSpan,
          cellRenderer: params => {
            if (params.value !== null && params.value !== undefined) {
              return `<span>${Number(params.value).toLocaleString('en')}</span>`
            }
          },
          tooltipValueGetter: params => {
            return this.$displayCurrency(params.data.revenue)
          },
          // cellClass: "grid-cell-centered",
          cellStyle: cellStyle,
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 110,
          maxWidth: 110
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.employee'),
          field: 'username',
          rowSpan: rowSpan,
          cellRenderer: params => {
            if (params.value) {
              return `<span>${params.value}</span>`
            }
          },
          // cellClass: "grid-cell-centered",
          cellStyle: cellStyle,
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          tooltipField: 'username',
          minWidth: 100
          // cellClass: "grid-cell-centered",
        }
      ],
      rows: []
    }
  },
  computed: {
    recode() {
      return this.searchParams.bookingCode
    },
    formatNumberField() {
      return ['average_charge', 'discount', 'refund', 'revenue']
    }
  },
  watch: {
    recode: {
      handler(val) {
        if (val) {
          this.disabledDate = true

          this.datetimeRange = {
            start: null,
            end: null
          }
          this.searchParams.dateFrom = null
          this.searchParams.dateTo = null
          this.searchParams.hotelId = []
          this.searchParams.sourceId = null
          this.searchParams.userId = null
        } else {
          this.disabledDate = false
          this.datetimeRange = {
            start: this.$moment().format('YYYY-MM-DD'),
            end: this.$moment().format('YYYY-MM-DD')
          }
          this.searchParams.dateFrom = this.$moment().format('YYYY-MM-DD')
          this.searchParams.dateTo = this.$moment().format('YYYY-MM-DD')
        }
      },
      deep: true
    }
  },
  created() {
    this.getListHotel()
    this.getListSource()
    this.getListAgent()
  },
  mounted() {
    this.attachData()
  },
  methods: {
    displayNumber(row, column, cellValue) {
      // console.log('rowwww2,', row, cellValue)
      return this.$displayCurrency(cellValue)
    },
    objectSpanMethod(data) {
      // 0 1 2 (3, 4) 5  (10) 11 12 13 14
      if (
        data.columnIndex <= 2 ||
        data.columnIndex === 5 ||
        data.columnIndex >= 11
      ) {
        if (data.row.rowSpan !== undefined)
          return {
            rowspan: data.row.rowSpan,
            colspan: 1
          }
        else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      } else if (
        data.columnIndex == 3 ||
        data.columnIndex == 4 ||
        data.columnIndex == 10
      ) {
        if (data.row.rowSpan1 !== undefined)
          return {
            rowspan: data.row.rowSpan1,
            colspan: 1
          }
        else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    headerHeightSetter() {
      var padding = 40
      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    },
    handleCommand(cmmd) {
      if (cmmd == 'excel') {
        getListReservationReportExcel(this.searchParams).then(res => {
          if (res) {
            const date = this.$moment().format('DD-MM-YYYY')
            const href = URL.createObjectURL(res)
            // create "a" HTML element with href to file & click
            const link = document.createElement('a')
            link.href = href
            link.setAttribute(
              'download',
              'reservation_report_' + date + '.xlsx'
              // res.headers['content-disposition'].split('filename=')[1],
            ) // or any other extension
            document.body.appendChild(link)
            link.click()
            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          } else {
            throw new Error(res)
          }
        })
      }
    },
    async getListSource() {
      const data = await getSourceApi({ isActive: 1 })
      this.sourceOptions = data.data
    },
    merge(arr1, arr2) {
      return [...new Set([...arr1, ...arr2])]
    },
    async getListAgent() {
      let dataSales = await getAllSales()
      let dataFO = await getAllFO()
      dataSales = dataSales.data.map(item => item.account)
      dataFO = dataFO.data.map(item => item.account)
      let dataAgent = [...dataSales, ...dataFO]
      let filteredList = [...new Set(dataAgent.map(JSON.stringify))].map(
        JSON.parse
      )
      this.agentOptions = filteredList
    },
    onSelectRowSource(val) {
      this.searchParams.sourceId = val?.id
    },
    onSelectRowAgent(val) {
      this.searchParams.userId = val?.id
    },
    tranferData(data) {
      let newDataRow = []

      data.forEach(data => {
        // let newDataRow = []
        if (data.booking_leve_room?.[0]) {
          let rowSpan = 0
          let dataRowChild = []
          data?.booking_leve_room.forEach(element => {
            if (element.room_bookings?.[0]) {
              element.room_bookings[0] = {
                ...element.room_bookings[0],
                // room_booking_code: element.room_bookings,
                room_level_name: element.room_level_name,
                num_of_rooms: element.num_of_rooms,
                rowSpan1: element.room_bookings.length
              }
              rowSpan += element.room_bookings.length
              dataRowChild = [...dataRowChild, ...element.room_bookings]
            }
          })
          dataRowChild[0] = {
            ...dataRowChild[0],
            rowSpan: rowSpan,
            code: data.code,
            num_of_booking_room: data.num_of_booking_room,
            revenue: data.revenue,
            refund: data.refund,
            discount: data.discount,
            source_name: data.source_name,
            username: data.username,
            booker: data.booker
          }
          newDataRow = [...newDataRow, ...dataRowChild]
          // data.guest_cancel_detail[0] = {
          //   ...data.guest_cancel_detail[0],
          //   room_booking_code: data.room_booking_code,
          //   rowSpan: data.guest_cancel_detail.length
          // }
          // newDataRow = [...newDataRow, ...data.guest_cancel_detail]
        }
      })
      // data.forEach(data => {
      //   let newDataRow = []
      return newDataRow
      // })
    },
    async attachData() {
      try {
        this.loading = true
        let data = await getListReservationReport(this.searchParams)
        this.loading = false
        this.rows = this.tranferData(data.data)

        // this.rows = data.data
      } catch {
      } finally {
        this.loading = false
      }
    },
    setDateRange(range) {
      this.searchParams.dateFrom = range.start
      this.searchParams.dateTo = range.end
    },
    onReset() {
      this.searchParams = { ...this.defaultSearchParams }
      this.datetimeRange = { ...this.defaultDatetimeRange }
      this.attachData()
    }
  }
}
</script>

<style lang="scss">
.grid-scroll {
  .ag-cell-focus,
  .ag-cell-no-focus {
    border: 0.5px !important;
  }
  /* This CSS is to not apply the border for the column having 'no-border' class */
  .no-border.ag-cell:focus {
    border: 0.5px !important;
    outline: none;
  }
}
</style>
